<nav class="navbar navbar-expand-lg navbar-light border " aria-label="logo" style=" background-color:white !important">
    <a id="gmplogo" class="navbar-brand" style="margin-left: 20px;"> <img id="gmplogoimg" [src]="gmplogoimg"
            alt="GMF logo"></a>
</nav>
<nav class="navbar navbar-expand-lg" aria-label="Language">
    <div class="form-floating mb-3" style="width:120px;margin-left: 20px;">
        <select class="form-control form-select" #selectedLanguage (change)="switchLang(selectedLanguage.value)">
            <option *ngFor="let language of translate.getLangs()" [value]="language"
                [selected]="language === translate.currentLang">
                {{ language | translate}}
            </option>
        </select>
        <label class="col-form-label">{{'LangLabel' | translate}}</label>
    </div>
</nav>
<div class="container" id="upload">
    <div id="upload-row" class="row">
        <div id="upload-column" class="panel">
            <div id="upload-box">
               <div class="table-container">
        <div class="table-responsive">
            <table class="table table-fixed-height" aria-label="List of bot files and last update date">
                <thead>
                    <tr>
                        <th scope="col" (click)="sortFiles('mmType')"> {{'MediaLabel' | translate}}
                            <span class="sort-icons">
                                <i class="bi bi-arrow-up"
                                    [ngClass]="{'active': sortColumn === 'mmType' && sortDirection === 'asc'}"></i>
                                <i class="bi bi-arrow-down"
                                    [ngClass]="{'active': sortColumn === 'mmType' && sortDirection === 'desc'}"></i>
                            </span>
                        </th>
                        <ng-container>
                            <th scope="col" (click)="sortFiles('brand')">{{ 'BrandLabel' | translate }}
                                <span class="sort-icons">
                                    <i class="bi bi-arrow-up"
                                        [ngClass]="{'active': sortColumn === 'brand' && sortDirection === 'asc'}"></i>
                                    <i class="bi bi-arrow-down"
                                        [ngClass]="{'active': sortColumn === 'brand' && sortDirection === 'desc'}"></i>
                                </span>
                            </th>
                            <th scope="col" (click)="sortFiles('productType')">{{ 'ProductLabel' | translate }}
                                <span class="sort-icons">
                                    <i class="bi bi-arrow-up"
                                        [ngClass]="{'active': sortColumn === 'productType' && sortDirection === 'asc'}"></i>
                                    <i class="bi bi-arrow-down"
                                        [ngClass]="{'active': sortColumn === 'productType' && sortDirection === 'desc'}"></i>
                                </span>
                            </th>
                            <th scope="col" (click)="sortFiles('fileDescription')">{{ 'DescLabel' | translate}}
                                <span class="sort-icons">
                                    <i class="bi bi-arrow-up"
                                        [ngClass]="{'active': sortColumn === 'fileDescription' && sortDirection === 'asc'}"></i>
                                    <i class="bi bi-arrow-down"
                                        [ngClass]="{'active': sortColumn === 'fileDescription' && sortDirection === 'desc'}"></i>
                                </span>
                            </th>
                            <th scope="col" (click)="sortFiles('language')">{{ 'LangLabel' | translate}}
                                <span class="sort-icons">
                                    <i class="bi bi-arrow-up"
                                        [ngClass]="{'active': sortColumn === 'language' && sortDirection === 'asc'}"></i>
                                    <i class="bi bi-arrow-down"
                                        [ngClass]="{'active': sortColumn === 'language' && sortDirection === 'desc'}"></i>
                                </span>
                            </th>
                            <th scope="col" (click)="sortFiles('timeStamp')">{{ 'TimestampLabel' | translate}}
                                <span class="sort-icons">
                                    <i class="bi bi-arrow-up"
                                        [ngClass]="{'active': sortColumn === 'timeStamp' && sortDirection === 'asc'}"></i>
                                    <i class="bi bi-arrow-down"
                                        [ngClass]="{'active': sortColumn === 'timeStamp' && sortDirection === 'desc'}"></i>
                                </span>
                            </th>
                            
                        </ng-container>
                        <th scope="col">{{'ViewBrochuresLabel' | translate}}</th>
                    
                    </tr>
                    <tr>
                        <th scope="col"><input type="text" class="form-control" placeholder="{{'SearchByPlaceholder' | translate}} {{'MediaLabel' | translate}}"
                                [(ngModel)]="searchMediaType" (input)="filterFilesByCategory()"></th>
                        <ng-container>
                            <th scope="col"><input type="text" class="form-control" placeholder="{{'SearchByPlaceholder' | translate}} {{'BrandLabel' | translate}}"
                                    [(ngModel)]="searchBrand" (input)="filterFilesByCategory()"></th>
                            <th scope="col"><input type="text" class="form-control" placeholder="{{'SearchByPlaceholder' | translate}} {{'ProductLabel' | translate}}"
                                    [(ngModel)]="searchProduct" (input)="filterFilesByCategory()"></th>
                            <th scope="col"><input type="text" class="form-control" placeholder="{{'SearchByPlaceholder' | translate}} {{'DescLabel' | translate}}"
                                    [(ngModel)]="searchDescription" (input)="filterFilesByCategory()"></th>
                            <th scope="col"><input type="text" class="form-control" placeholder="{{'SearchByPlaceholder' | translate}} {{'LangLabel' | translate}}"
                                    [(ngModel)]="searchLanguage" (input)="filterFilesByCategory()"></th>
                            <th scope="col"><input type="text" class="form-control" placeholder="{{'SearchByPlaceholder' | translate}} {{'TimestampLabel' | translate}}"
                                    [(ngModel)]="searchTimestamp" (input)="filterFilesByCategory()"></th>
                        </ng-container>

                        <th scope="col"></th>
                
                    </tr>
                </thead>                <tbody>
                    <tr *ngFor="let file of paginatedFiles">
                        <td><span [title]="translateMediaType(file.mmType)">{{ translateMediaType(file.mmType) }}</span></td>
                        <td><span [title]="translateBrand(file.brand, file.mmType)">{{ translateBrand(file.brand, file.mmType) }}</span></td>
                        <td><span [title]="translateProductType(file.productType, file.brand, file.mmType)">{{ translateProductType(file.productType, file.brand, file.mmType) }}</span></td>
                        <td><span [title]="file.fileDescription">{{ file.fileDescription }}</span></td>
                        <td><span [title]="translateLanguage(file.language)">{{ translateLanguage(file.language) }}</span></td>
                        <td><span [title]="file.timeStamp | date:'MM/dd/yyyy HH:mm:ss'">{{ file.timeStamp | date:'MM/dd/yyyy' }}</span></td>
                        <td>
                            <button class="btn btn-link table-link" (click)="viewPdf(file)">
                              {{'ViewBrochuresLabel' | translate}}
                            </button>
                        </td>
                    </tr>
                    <tr *ngIf="paginatedFiles.length === 0">
                        <td colspan="6" class="text-center">No files found</td>
                    </tr>
                </tbody>
            </table>
        </div>

    </div>
            </div>
        </div>

        <div class="pagination-container d-flex justify-content-end">
            <ngb-pagination [collectionSize]="filteredFiles.length" [(page)]="currentPage" [maxSize]="5"
                [boundaryLinks]="true" (pageChange)="changePage($event)"></ngb-pagination>
        </div>

    </div>

    <!-- Bootstrap PDF modal - Always available in DOM -->
    <div class="modal fade" id="pdfModal" tabindex="-1" aria-labelledby="pdfModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="pdfModalLabel">{{ 'pdfModalLabel' | translate }}</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div *ngIf="!pdfSource" class="text-center p-4">
                        <p>{{ 'Loading PDF...' | translate }}</p>
                    </div>
                    <iframe width="100%" height="600px" [src]="pdfSource" title="GM protection PDF Viewer" *ngIf="pdfSource"></iframe>
                </div>
            </div>
        </div>
    </div>
    <!-- Bootstrap video modal - Always available in DOM -->
    <div class="modal fade" id="videoModal" tabindex="-1" aria-labelledby="videoModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="videoModalLabel">{{ 'videoModalLabel' | translate }}</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="stopVideo()"></button>
                </div>
                <div class="modal-body">
                    <div *ngIf="!videoSource" class="text-center p-4" id="loadingVideo">
                        <p>{{ 'loadingVideo' | translate }}</p>
                        <div class="alert alert-warning" id="videoError">
                            <p>{{ 'videoError' | translate }}</p>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center align-items-center" id="videoNotSupported" *ngIf="videoSource">
                        <!-- Video player using object tag -->
                        <object 
                            width="100%" 
                            height="500px" 
                            [data]="videoSource"
                            type="video/mp4"
                            style="background-color: #000;">
                            <p>{{ 'videoNotSupported' | translate }}</p>
                        </object>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-pulse"
    [fullScreen]="true"></ngx-spinner>